import { render, staticRenderFns } from "./NrkResources.vue?vue&type=template&id=083f27de&scoped=true"
import script from "./NrkResources.vue?vue&type=script&lang=js"
export * from "./NrkResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f27de",
  null
  
)

export default component.exports